import { Route, Routes, Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { selectUserPermissions, selectUserRoles } from '@store/auth';

import MCCImage from '@assets/images/conversion-rates/exchange.png';
import Points from '@assets/images/conversion-rates/points.png';
import PointsExchange from '@assets/images/conversion-rates/points-exchange.png';

import { SidePanelImage } from '../../components/styledComponents';
import ApplicationTemplate from '../dashboard/components/ApplicationTemplate/ApplicationTemplate';

// Pages
import MCCRates from './pages/MCCRates';
import LoyaltyPointsRates from './pages/LoyaltyPointsRates';
import LoyaltyPointsConfiguration from './pages/LoyaltyConfiguration';

import { getFirstRoute } from '../../utils/utils';

import { LP_CONFIG, LP_RATES, MCC_RATES } from './conversion-rates.breadcrumbs';
import { ROLES } from '../../app/App.constants';

const tabs = [
  {
    title: 'MCC Rates',
    icon: (
      <SidePanelImage
        src={MCCImage}
        alt="MCC"
      />
    ),
    path: MCC_RATES,
    roles: [ROLES.ROLE_MCC_EDIT, ROLES.ROLE_MCC_VIEW],
  },
  {
    title: 'Loyalty Points Rates',
    icon: (
      <SidePanelImage
        src={PointsExchange}
        alt="Loyalty Points"
      />
    ),
    path: LP_RATES,
    roles: [ROLES.ROLE_LOYALTY_EDIT, ROLES.ROLE_LOYALTY_VIEW],
  },
  {
    title: 'Loyalty Configuration',
    icon: (
      <SidePanelImage
        src={Points}
        alt="Loyalty Configuration"
      />
    ),
    path: LP_CONFIG,
    roles: [ROLES.ROLE_LOYALTY_EDIT, ROLES.ROLE_LOYALTY_VIEW],
  },
];

function ConversionRates() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="mcc/rates"
          exact
          element={<MCCRates permissions={permissions} />}
        />
        <Route
          path="loyalty-points/rates"
          exact
          element={<LoyaltyPointsRates permissions={permissions} />}
        />
        <Route
          path="loyalty-points/config"
          exact
          element={<LoyaltyPointsConfiguration permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default ConversionRates;
